"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _classnames3 = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _selectors = require("../../store/selectors");
var _constants = require("../../constants");
var _arrow = _interopRequireDefault(require("./arrow.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ARROW__RIGHT_BUTTON = 'ArrowRight';
var ARROW__LEFT_BUTTON = 'ArrowLeft';
var handleKeyboardPress = function handleKeyboardPress(onKeyDown) {
  return function (event) {
    return R.includes(event.code, [ARROW__RIGHT_BUTTON, ARROW__LEFT_BUTTON]) && onKeyDown(event.code);
  };
};
var getNextCategoryIDByActive = function getNextCategoryIDByActive(activeCategoryID, categories) {
  return R.path([R.inc(R.findIndex(R.propEq(activeCategoryID, 'id'), categories)), 'id'], categories);
};
var getPrevCategoryIDByActive = function getPrevCategoryIDByActive(activeCategoryID, categories) {
  return R.prop('id', categories[R.dec(R.findIndex(R.propEq(activeCategoryID, 'id'), categories))]);
};
var PhotoGalleryNav = function PhotoGalleryNav(_ref) {
  var activeCategoryID = _ref.activeCategoryID,
    categories = _ref.categories,
    onCategoryChange = _ref.onCategoryChange;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULTS'),
    t = _useTranslation.t;
  var sliderLisRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeSlide = _useState2[0],
    setActiveSlide = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDisabledNext = _useState4[0],
    setIsDisabledNext = _useState4[1];
  var shouldDisableKeyboard = (0, _reactRedux.useSelector)(_selectors.isOpenSingleGalleryModal);
  var isDisabledPrev = activeSlide === 0;
  var sliderProgress = (0, _react.useMemo)(function () {
    return sliderLisRef.current ? R.call(R.pipe(R.map(function (index) {
      return sliderLisRef.current.children[index].offsetWidth;
    }), R.sum, function (offsetPx) {
      return offsetPx * 100 / (sliderLisRef.current.clientWidth - 88) * -1;
    }), R.range(0, activeSlide)) : 0;
  }, [activeSlide]);
  var nextCategoryID = (0, _react.useMemo)(function () {
    return getNextCategoryIDByActive(activeCategoryID, categories);
  }, [activeCategoryID, categories]);
  var prevCategoryID = (0, _react.useMemo)(function () {
    return getPrevCategoryIDByActive(activeCategoryID, categories);
  }, [activeCategoryID, categories]);
  var handleNextSlide = (0, _react.useCallback)(function () {
    return setActiveSlide(R.inc);
  }, []);
  var handlePrevSlide = (0, _react.useCallback)(function () {
    return setActiveSlide(R.dec);
  }, []);
  (0, _react.useEffect)(function () {
    var listNode = sliderLisRef.current;
    var visibleWidthPx = listNode.offsetWidth - sliderProgress * -1 * listNode.offsetWidth / 100;
    var visibleScreen = listNode.parentElement.offsetWidth;
    setIsDisabledNext(visibleWidthPx <= visibleScreen);
  }, [sliderProgress]);
  (0, _react.useEffect)(function () {
    if (!shouldDisableKeyboard) {
      var handler = handleKeyboardPress(function (pressedButton) {
        return pressedButton === ARROW__RIGHT_BUTTON ? (!isDisabledNext && handleNextSlide(), nextCategoryID && onCategoryChange(nextCategoryID)) : (!isDisabledPrev && handlePrevSlide(), prevCategoryID && onCategoryChange(prevCategoryID));
      });
      global.window.addEventListener('keydown', handler);
      return function () {
        global.window.removeEventListener('keydown', handler);
      };
    }
  }, [categories.length, handleNextSlide, handlePrevSlide, isDisabledNext, isDisabledPrev, nextCategoryID, onCategoryChange, prevCategoryID, shouldDisableKeyboard]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.categoriesBar
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.categoriesSliderContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.categoriesSlider
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.categoriesList,
    ref: sliderLisRef,
    style: {
      transform: "translateX(".concat(sliderProgress, "%)")
    }
  }, R.map(function (_ref2) {
    var id = _ref2.id,
      name = _ref2.name;
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      key: id,
      theme: id === activeCategoryID ? _Button.THEMES.PURPLE : _Button.THEMES.GREY,
      onClick: function onClick() {
        return onCategoryChange(id);
      }
    }, id === _constants.WITHOUT_CATEGORY_PHOTO_CATEGORY_NAME.id ? t('GALLERY_PHOTOS_EMPTY_CATEGORY_LABEL') : name);
  }, categories))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.categoriesPrev, _defineProperty({}, _styles.default.disabled, isDisabledPrev)),
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    },
    onClick: !isDisabledPrev ? handlePrevSlide : undefined
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.categoriesNext, _defineProperty({}, _styles.default.disabled, isDisabledNext)),
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    },
    onClick: !isDisabledNext ? handleNextSlide : undefined
  })));
};
PhotoGalleryNav.propTypes = {
  activeCategoryID: _propTypes.default.number.isRequired,
  categories: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number.isRequired,
    name: _propTypes.default.string.isRequired
  })).isRequired,
  onCategoryChange: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _react.memo)(PhotoGalleryNav);